import React from 'react';
import PropTypes from 'prop-types';
import './LoadingIndicator.css';

const LoadingIndicator = ({ loading, small }) => {
  if (!loading) {
    return null;
  }

  let circleClasses = 'spinner-circle';
  circleClasses += small ? ' small' : ' large';

  return (
    <div className={circleClasses}>
      <div className="spinner-ball" />
    </div>
  );
};

LoadingIndicator.propTypes = {
  loading: PropTypes.bool,
  small: PropTypes.bool,
};

LoadingIndicator.defaultProps = {
  loading: true,
  small: false,
};

export default LoadingIndicator;
